import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-shared-site-loader',
    templateUrl: './site-loader.component.html',
    styleUrls: ['./site-loader.component.scss']
})

export class SharedSiteLoaderComponent implements OnInit {
    
    constructor() {
    }
    
    ngOnInit() {
    }
    
}
